import React, { useState } from "react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { useSelector, useDispatch } from "react-redux";
import { updateUser } from "../../slices/authSlice"; 
import { updateProfile } from "../../api/apiCall"; 
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const Profile = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const MySwal = withReactContent(Swal);

  const [formData, setFormData] = useState({
    fullname: user.name || "",
    email: user.email || "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Fonction pour afficher une alerte stylisée
  const showAlert = (config) => {
    MySwal.fire({
      ...config,
      icon: config.type || "success",
      confirmButtonText: "OK",
    });
  };

  // Gestion des modifications dans les champs d'entrée
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Fonction pour soumettre les modifications
  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    // Validation des champs
    if (!formData.fullname.trim() || !formData.email.trim()) {
      setError("Veuillez remplir tous les champs.");
      setLoading(false);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError("Veuillez entrer une adresse e-mail valide.");
      setLoading(false);
      return;
    }

    try {
      // Appel API pour mettre à jour le profil
      const response = await updateProfile({
        name: formData.fullname,
        email: formData.email,
      });

      const updatedUser = response.data.user;

      // Mettre à jour le store Redux
      dispatch(updateUser(updatedUser));

      // Afficher une alerte de succès
      showAlert({
        text: "Profil mis à jour avec succès !",
        type: "success",
      });
    } catch (err) {
      // Afficher une erreur en cas d'échec
      setError("Une erreur s'est produite lors de la mise à jour. Réessayez."+ err);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="page-header">
          <div className="page-title">
            <h4>Profil</h4>
            <h6>Modifier vos informations personnelles</h6>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleUpdate}>
              <div className="profile-set">
                <div className="profile-head"></div>
                <div className="profile-top">
                  <div className="profile-content">
                    <div className="profile-contentimg">
                      <ImageWithBasePath
                        src="assets/img/avatar/customer.jpg"
                        alt="avatar"
                      />
                    </div>
                    <div className="profile-contentname">
                      <h2>{user.name}</h2>
                      <h4>{user.role?.name || "Utilisateur"}</h4>
                    </div>
                  </div>
                </div>
              </div>

              <div className="input-blocks">
                <label>Nom complet</label>
                <input
                  type="text"
                  name="fullname"
                  value={formData.fullname}
                  onChange={handleChange}
                  className="form-control"
                  disabled={loading}
                />
              </div>
              <div className="input-blocks">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="form-control"
                  disabled={loading}
                />
              </div>
              {error && <p className="text-danger">{error}</p>}
              <div className="profile-actions">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "En cours..." : "Mettre à jour"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
